export { default } from './HostedVoice.container'



// WEBPACK FOOTER //
// ./src/pages/Services/HostedVoice/index.js